module.exports = __webpack_public_path__ + "img/gem-found-green.1b085ff5.png";